import Home from "./layouts/Home";
import Services from "./layouts/Services";
import Works from "./layouts/Works";
import About from "./layouts/About";
import Contact from "./layouts/Contact";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Work from "./layouts/Work";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/work" element={<Work />} />
        <Route path="/works" element={<Works />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
